import axios from "axios";
import {API_URL, localStorageValue} from '../../all-pages'

/**
 * function PostUser
 * @param BaseUrl
 * @param id
 * @param dataForm
 */

type Props = {
    BaseUrl: string | undefined,
    id: string,
    dataForm: object,
}
export default async function PostUser( {
                                      BaseUrl,
                                      id,
                                      dataForm,
                                  } : Props
) {

    const formData = new FormData();

    for (const [key, value] of Object.entries(dataForm)) {

        formData.append(key, value);
    }
     const data = await axios({

            method: 'POST',
            url: `${API_URL}${BaseUrl}${id}`,
            headers: {
                'Authorization': 'Bearer ' + localStorageValue,
            },
            data: formData,
        })

    return data;
}